import { Col, Row, notification } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DFormEntity } from '../../../api/fetchDoctorGenieByOID';
import { GeniePadElementsSettingItem, GenieSettings } from '../../../api/pushGenie';
import { dispatch as ekaEventDispath } from '../../../bridge/events/dispatch';
import {
    ADD_NEW_PT_APPT,
    DESTROY_CONTAINER,
    NEW_PT_FORM_DATA,
    NEW_PT_FORM_DATA_AS_SELECTED,
    PATIENT_ABHA_CREATE,
} from '../../../bridge/events/types';
import { DYNAMIC_FORMS, FAMILY_MEMBERS_NAME } from '../../../constants';
import { Gender } from '../../../pages/NewPatient';
import { Data, decodeAge } from '../../../pages/PatientInfoComp';
import {
    LS_NEW_PT_DF_AS,
    capitalizeString,
    checkIfValidPhoneNumber,
    getAddPDForms,
} from '../../../pages/utils';
import { NewPatient as AddPatientNewPatient, addPatient } from '../../../store/actions/app';
import { updateAddPtDyForm } from '../../../store/actions/session';
import {
    MISC_KEYS,
    getDoctorSelectorList,
    getItemFromMisc,
    getMe,
    getMyClinics,
    getSelectedClinicId,
} from '../../../store/idbHandler';
import { Patient } from '../../../store/types/patient';
import { getUnit } from '../../../store/utils';
import { track } from '../../../tracking';
import PatientUhidAutoSuggest from '../../PatientUhidAutoSuggest';
import { SuggestUHID } from '../PatientInfoForm';
import { DAYS, MALE_SALUTATION, MARITAL_STATUS, MONTHS, YEARS } from '../constants/add-patient';
import CongigureElemtsTableDialog from './ConfigureElementsTableDialog';
import { getGenieSetting, getMonthlyAbhaLoss } from '../../../store/selectors/session';
import { GlobalStateV1 } from '../../../store/reducers';
import { useLocation, useParams } from 'react-router-dom';
import NoABDMPopver from '../NoABDMPopver';
import NewPatientModalWrapper from './NewPatientModalWrapper';
import CreateAbhaForm from '../../abha/CreateAbhaForm';
import PatientNameAutoSuggestBlock from '../../PatientNameAutoSuggestBlock';
import PatientPhoneAutoSuggestBlock from '../../PatientPhoneAutoSuggestBlock';
import AgeInputBlock from '../../AgeInputBlock';
import GenderBlock from '../../GenderBlock';
import AbhaCard from '../../abha/AbhaCard';
import { AbhaIconNotLinked } from '../Icons';
import CurrMonthLossStrip from '../CurrMonthLossStrip';
import { captureError } from '../../../pages/captureError';
import PatientPhoneNumber from '../../PatientPhoneNumber';
import PatientReferralAutoSuggest from '../../PatientReferralAutoSuggest';
import { CountryCode } from 'libphonenumber-js';
import { getMyDbId } from '../../../api/mactiveid';
import { LANGS } from '../../prescriptionPad/rightPanel/previewScreen/PreviewPanel';
import { InitialNewPatientState } from '../../RelatedProfiles/AddRelationsModal';

type IFormState = 'abha' | 'add-pt';

interface Props {
    cId: string;
    close: () => void;
    callback?: (patient: Patient) => void;
    hideABHAFlow?: boolean;
    defaultFormState?: IFormState;
    isAbhaNewFlow: boolean;
    abhaLinkPatient?: Patient;
    onAbhaLink?: (pt: Patient) => void;
    onSendOtp?: () => void;
    isSendAbhaOtp?: boolean;
    docid: string;
    defaultAbhaId?: string;
    defaultAbhaPtOid?: string;
    initialState?: InitialNewPatientState;
    defaultShowAbhaCard?: boolean;
}

interface NewPtModalProps extends Props {
    formState?: IFormState;
    setAddPtFormState?: (formstate: IFormState | undefined) => void;
    initialState?: InitialNewPatientState;
    defaultShowAbhaCard?: boolean;
    defaultAbhaPtOid?: string;
}

const getAgestring = (
    ageDays: string | undefined,
    ageMonth: string | undefined,
    dob:
        | {
              dd?: string;
              mm?: string;
              yyyy?: string;
          }
        | undefined,
) => {
    let date;

    if (dob) {
        date = moment(`${dob.mm}/${dob.dd}/${dob.yyyy}`, 'MM/DD/YYYY');
        return `${moment().diff(date, 'years', false).toString()} Y`;
    }

    if (ageDays) {
        date = moment().subtract(parseInt(ageDays), 'days');
    } else if (ageMonth) {
        date = moment().subtract(parseInt(ageMonth), 'months');
    } else {
        date = moment('01/01/1992', 'MM/DD/YYYY');
    }

    return `${moment().diff(date, 'years', false).toString()} Y`;
};

const NewPatientModal: React.FC<NewPtModalProps> = ({
    cId,
    close,
    callback,
    hideABHAFlow,
    formState,
    setAddPtFormState,
    isAbhaNewFlow,
    abhaLinkPatient,
    onAbhaLink,
    isSendAbhaOtp,
    docid,
    defaultAbhaId,
    initialState,
    defaultShowAbhaCard,
    defaultAbhaPtOid,
}) => {
    const dispatch = useDispatch();
    const params: { cId: string } = useParams();
    const location = useLocation();
    const initialPhoneNumber = initialState?.phoneNumber
        ? initialState.phoneNumber
        : abhaLinkPatient
        ? abhaLinkPatient.personal.phone?.n
        : undefined;
    const initialPhCode = initialState?.phCode
        ? initialState.phCode
        : abhaLinkPatient?.personal.phone?.c
        ? abhaLinkPatient.personal.phone?.c
        : '+91';
    const initialStateName = initialState?.name
        ? initialState.name
        : abhaLinkPatient
        ? abhaLinkPatient.personal.name.f
        : undefined;
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>(initialPhoneNumber);
    const [phCode, setPhCode] = useState<string>(initialPhCode);
    const [name, setName] = useState<string | undefined>(initialStateName);
    const [isPhoneNumberError, setIsPhoneNumberError] = useState<boolean>(false);
    const [isNameError, setIsNameError] = useState<boolean>(false);
    const [isDobError, setIsDobError] = useState<boolean>(false);
    const [isAgeDOBError, setIsAgeDOBError] = useState<boolean>(false);
    const [isGenderError, setIsGenderError] = useState<boolean>(false);
    const [ageDays, setAgeDays] = useState<string>();
    const [age, setAge] = useState<string>();
    const [ageMonth, setAgeMonth] = useState<string>();
    const [gender, setGender] = useState<Gender | undefined>(
        initialState?.gender ||
            (abhaLinkPatient ? (abhaLinkPatient.personal.gender as Gender) : undefined),
    );
    const [dForm, setDform] = useState<DFormEntity[]>();
    const [dfValues, setDfValues] = useState<{ [k: string]: string | number }>({});
    const [showOtherFields, setShowOtherFields] = useState(false);
    const [dyFormSuggestions, setDyFromSuggestions] = useState<{
        [k: string]: (string | number)[];
    }>({});
    const [currMomentDate, setCurrentMomentDate] = useState<moment.Moment | null>(null);
    const [configureDialogVisible, setConfigureDialogVisible] = useState(false);
    const [isPhoneInputDisabled, setIsPhoneInputDisabled] = useState(false);
    const [isNameInputDisabled, setIsNameInputDisabled] = useState(false);
    const [isAgeInputDisabled, setIsAgeInputDisabled] = useState(false);
    const [isGenderInputDisabled, setIsGenderInputDisabled] = useState(false);
    const [localId, setLocalId] = useState<string | undefined>(undefined);
    const [showAbhaCard, setShowAbhaCard] = useState<boolean>(defaultShowAbhaCard || false);
    const [abhaId, setAbhaId] = useState<string | undefined>(defaultAbhaId);
    const [createSkipState, setCreateSkipState] = useState<string>();
    const [authHealthId, setAuthHealthId] = useState<string | undefined>(
        abhaLinkPatient
            ? abhaLinkPatient.personal['health-ids']
                ? abhaLinkPatient.personal['health-ids'][0]
                : undefined
            : undefined,
    );
    const [isReferralPhoneNumberError, setIsReferralPhoneNumberError] = useState(false);
    const [showSendOtpScreen, setShowSendOtpScreen] = useState(false);
    const [ptId, setPtId] = useState<string | undefined>(
        abhaLinkPatient ? abhaLinkPatient.id : undefined,
    );
    const [referDocId, setReferDocId] = useState<string | undefined>(undefined);

    const currMonthLoss = useSelector(getMonthlyAbhaLoss);
    const isAbdmEnabled = useSelector((state: GlobalStateV1) =>
        getGenieSetting(state, 'abdm'),
    ) as boolean;
    const [showSendOtp, setShowSendOtp] = useState(true);

    const [autoSelectPt, setAutoSelectPt] = useState<Patient | undefined>(undefined);
    const [allowEkaEvent, setAllowEkaEvent] = useState(false);
    const [phCodeEnum, setphCodeEnum] = useState<CountryCode | undefined>('IN');
    const [fromNdhmDiscovery, setFromNdhmDiscovery] = useState<boolean | undefined>(false);
    const [abhaPtOid, setAbhaPtOid] = useState<string | undefined>(defaultAbhaPtOid);
    const [isAddingPatient, setIsAddingPatient] = useState(false);

    const setAddPtFormStateWithTracking = (formState: IFormState | undefined) => {
        if (setAddPtFormState) {
            track('GO_TO_ADD_PT', {
                createSkipState: createSkipState ?? '',
                showAbhaCard: String(showAbhaCard),
                formState,
            });
        }
        setAddPtFormState && setAddPtFormState(formState);
    };

    const clinicHfr = getMyClinics()?.find(
        (c) => c._id === (cId || params.cId || getSelectedClinicId()),
    )?.abdm?.hfr_id;

    const isAbhaOnboarded = !!clinicHfr;

    const rawDob = initialState?.dob || abhaLinkPatient?.personal?.age?.dob;

    const dobObj = rawDob ? rawDob.split('-') : undefined;

    const [dob, setDob] = useState<
        | {
              dd?: string;
              mm?: string;
              yyyy?: string;
          }
        | undefined
    >(
        dobObj
            ? { yyyy: dobObj[0], mm: dobObj[1], dd: dobObj[2] }
            : {
                  dd: '0',
                  mm: '0',
                  yyyy: '0',
              },
    );

    const fillNewPtData = (data: Data) => {
        const phNum = data?.phoneNumber?.replace('+91', '');

        setName(data?.name || name);
        setPhoneNumber(phNum || phoneNumber);
        setDob(data?.dob || dob);
        setAge(data?.age || age);
        setAgeMonth(data?.ageMonth || ageMonth);
        setAgeDays(data?.ageDays || ageDays);

        const dateOfBirth = data?.dob || dob;

        setCurrentMomentDate(
            dateOfBirth?.dd && dateOfBirth?.mm && dateOfBirth?.yyyy
                ? moment({
                      month: parseInt(dateOfBirth?.mm) - 1,
                      date: parseInt(dateOfBirth?.dd),
                      year: parseInt(dateOfBirth?.yyyy),
                  })
                : null,
        );

        setGender(data?.gender || gender);
        setDfValues(data?.dfValues || dfValues);
        setIsPhoneInputDisabled(true);
        setIsNameInputDisabled(true);
        setIsAgeInputDisabled(true);
        setIsGenderInputDisabled(true);
    };

    function updateDform() {
        getAddPDForms().then((dForm) =>
            setDform([
                { label: 'UHID', type: 'string', key: 'uhid' },
                ...dForm.filter((t) => t.key !== 'uhid'),
            ]),
        );
    }

    const onSendOtp = () => {
        if (!isSendAbhaOtp) {
            return;
        }

        setAllowEkaEvent(true);

        if (autoSelectPt) {
            ekaEventDispath({
                type: NEW_PT_FORM_DATA_AS_SELECTED,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data: { ...autoSelectPt, localId: undefined },
            });
        } else {
            let eventState = {
                name: name,
                phoneNumber: phoneNumber,
                dob: dob,
                age: age,
                ageMonth: ageMonth,
                ageDays: ageDays,
                gender: gender,
                isDobError: isDobError,
                isNameError: isNameError,
                isGenderError: isGenderError,
                isPhoneNumberError: isPhoneNumberError,
                isPhoneInputDisabled: isPhoneInputDisabled,
                isNameInputDisabled: isNameInputDisabled,
                isAgeInputDisabled: isAgeInputDisabled,
                isGenderInputDisabled: isGenderInputDisabled,
                dfValues: dfValues,
                localId: localId,
                autoSelectPt: autoSelectPt,
            };

            if (
                dob &&
                (dob.dd !== '0' ||
                    (dob.mm !== '0' && dob.mm !== '00') ||
                    (dob.yyyy !== '0' && dob.yyyy !== '0000'))
            ) {
                eventState = {
                    ...eventState,
                    age: undefined,
                    ageDays: undefined,
                    ageMonth: undefined,
                };
            } else {
                eventState = {
                    ...eventState,
                    dob: undefined,
                };
            }

            ekaEventDispath({
                type: NEW_PT_FORM_DATA,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data: { ...eventState, localId: undefined },
            });
        }
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.fillNewPtData = fillNewPtData;

        updateDform();
        setDyFromSuggestions(JSON.parse(localStorage.getItem(LS_NEW_PT_DF_AS) || '{}'));

        // if (isAbhaOnboarded && !showAbhaCard && formState === 'add-pt') {
        //     renderStuff(isAbdmEnabled, { ...params, link: 'false' }, location);
        // }

        // return () => {
        //     ekaEventDispath({
        //         type: DESTROY_CONTAINER,
        //         containerId: ABHA_IN_DOCTOOL_CONTAINER,
        //     });
        // };
    }, []);

    // useEffect(() => {
    //     if (isAbhaOnboarded && !showAbhaCard && formState === 'add-pt') {
    //         renderStuff(isAbdmEnabled, { ...params, link: 'false' }, location);
    //     }
    // }, [showAbhaCard]);

    useEffect(() => {
        if (
            (!isSendAbhaOtp || allowEkaEvent) &&
            isAbhaOnboarded &&
            !showAbhaCard &&
            formState === 'add-pt'
        ) {
            let eventState = {
                name: name,
                phCode: phCode,
                phoneNumber: phoneNumber,
                dob: dob,
                age: age,
                ageMonth: ageMonth,
                ageDays: ageDays,
                gender: gender,
                isDobError: isDobError,
                isNameError: isNameError,
                isGenderError: isGenderError,
                isPhoneNumberError: isPhoneNumberError,
                isPhoneInputDisabled: isPhoneInputDisabled,
                isNameInputDisabled: isNameInputDisabled,
                isAgeInputDisabled: isAgeInputDisabled,
                isGenderInputDisabled: isGenderInputDisabled,
                dfValues: dfValues,
                localId: localId,
            };

            if (
                dob &&
                (dob.dd !== '0' ||
                    (dob.mm !== '0' && dob.mm !== '00') ||
                    (dob.yyyy !== '0' && dob.yyyy !== '0000'))
            ) {
                eventState = {
                    ...eventState,
                    age: undefined,
                    ageDays: undefined,
                    ageMonth: undefined,
                };
            } else {
                eventState = {
                    ...eventState,
                    dob: undefined,
                };
            }

            ekaEventDispath({
                type: NEW_PT_FORM_DATA,
                data: {
                    ...eventState,
                    localId: undefined,
                    isReferralPhoneNumberError: false,
                    phCodeEnum: undefined,
                },
            });
        }
    });

    const onPhoneNumberChange = (input?: string): void => {
        setPhoneNumber(input);

        if (isPhoneNumberError) {
            setIsPhoneNumberError(!checkIfValidPhoneNumber(phCode, input, phCodeEnum));
        }
    };

    const onPhCodeChange = (input?: string, countryCodeEnum?: CountryCode): void => {
        setPhCode(input || '+91');
        setphCodeEnum(countryCodeEnum);

        if (isPhoneNumberError) {
            setIsPhoneNumberError(!checkIfValidPhoneNumber(phCode, input, countryCodeEnum));
        }
    };

    const onNameChange = (input?: string): void => {
        setName(input);
        setIsNameError(input ? input.length === 0 : false);
    };

    const onDDDobChange = (input: string): void => {
        setDob((prev) => ({ ...prev, dd: input }));
        setAge('0');
        setAgeMonth('0');
        setAgeDays(undefined);
    };

    const onMMDobChange = (input: string): void => {
        setDob((prev) => ({ ...prev, mm: input }));
        setAge('0');
        setAgeMonth('0');
        setAgeDays(undefined);
    };

    const onYYYYDobChange = (input: string): void => {
        setDob((prev) => ({ ...prev, yyyy: input }));
        setAge('0');
        setAgeMonth('0');
        setAgeDays(undefined);
    };

    const uhidDForm = dForm?.find((d) => d.key === 'uhid');
    const isPhCode = dForm?.find((d) => d.key === 'pcc');
    const dFormWithoutUHID = dForm?.filter((d) => d.key !== 'uhid' && d.key !== 'pcc');
    const salutation = dForm?.find((t) => t.key === 'salutation');

    const onDFChange = (df: DFormEntity) => (v: string): void => {
        let input: string | number = v;

        if (input === '') {
            setDfValues((prev) => ({ ...prev, [df.key]: '' }));
            return;
        }

        if (df.key === 'referredbynumber') {
            setIsReferralPhoneNumberError(!checkIfValidPhoneNumber(phCode, input, phCodeEnum));
        }

        if (df.type === 'number') {
            input = parseFloat(input.replace(/[^0-9]/g, ''));

            if (isNaN(input)) {
                return;
            }
        }

        setDfValues((prev) => ({ ...prev, [df.key]: input }));
    };

    const uhid = uhidDForm && dfValues[uhidDForm.key]?.toString();

    const onUhidInputChange = (input: string): void => {
        uhidDForm && onDFChange(uhidDForm)(input);
    };

    let value: {
        id: YEARS | MONTHS | DAYS;
        label: string;
        value: number;
    } | null = null;

    if (!dob || (dob.dd === '0' && dob.mm === '0' && dob.yyyy === '0')) {
        if (ageDays) {
            value = {
                id: 'DAYS',
                label: `${ageDays} ${getUnit('days', ageDays)}`,
                value: parseInt(ageDays),
            };
        } else if (age) {
            value = {
                id: 'YEARS',
                label: `${age} ${getUnit('years', age)}`,
                value: parseInt(age) * 12,
            };
        } else if (ageMonth) {
            const m = parseInt(ageMonth);
            if (m >= 12 && m % 12 === 0) {
                value = {
                    id: 'YEARS',
                    label: `${m / 12} ${getUnit('years', ageMonth)}`,
                    value: m * 1,
                };
            } else {
                value = {
                    id: 'MONTHS',
                    label: `${ageMonth} ${getUnit('months', ageMonth)}`,
                    value: m * 1,
                };
            }
        }
    }

    const onAgeSelect = (
        option: {
            id: YEARS | MONTHS | DAYS;
            label: string;
            value: number;
        } | null,
    ): void => {
        setCurrentMomentDate(null);

        if (!option) {
            setAgeDays(undefined);
            setAgeMonth(undefined);
            setAge(undefined);
            return;
        }

        if (option.id === 'DAYS') {
            setAgeMonth(undefined);
            setAgeDays(option.value.toString());
            setAge(undefined);
            setDob(undefined);
            setIsDobError(false);
            setIsAgeDOBError(false);
        } else {
            setAgeMonth(option.value.toString());
            setAgeDays(undefined);
            setDob(undefined);
            setAge(undefined);
            setIsDobError(false);
            setIsAgeDOBError(false);
        }
    };

    const onGenderChange = (gender?: Gender): void => {
        setGender(gender);
        setIsGenderError(false);
    };

    const errorValidation = () => {
        const isAgeDOBAbsent =
            !age &&
            !ageDays &&
            !ageMonth &&
            (!dob || (dob?.dd === '0' && dob?.mm === '0' && dob?.yyyy === '0'));

        if (
            !name ||
            (phoneNumber && !checkIfValidPhoneNumber(phCode, phoneNumber, phCodeEnum)) ||
            !gender ||
            (dfValues?.['referredbynumber'] &&
                !checkIfValidPhoneNumber(
                    '+91',
                    dfValues?.['referredbynumber']?.toString(),
                    'IN',
                )) ||
            isAgeDOBAbsent
        ) {
            if (phoneNumber && !checkIfValidPhoneNumber(phCode, phoneNumber, phCodeEnum)) {
                setIsPhoneNumberError(true);
            }

            if (
                dfValues?.['referredbynumber'] &&
                !checkIfValidPhoneNumber('+91', dfValues?.['referredbynumber']?.toString(), 'IN')
            ) {
                setIsReferralPhoneNumberError(true);
            }

            if (!name) {
                setIsNameError(true);
            }

            if (!gender) {
                setIsGenderError(true);
            }

            if (isAgeDOBAbsent) {
                setIsAgeDOBError(true);
            }

            return {
                success: false,
                data: { isAgeDOBAbsent, isDobError, name, phoneNumber, gender },
            };
        }

        let dobStr = '';

        if (ageDays) {
            const MS_IN_DAY = 24 * 60 * 60 * 1000;
            const todayDay = new Date().getTime() / MS_IN_DAY;
            const desiredDay = todayDay - parseInt(ageDays);
            dobStr = moment(new Date(desiredDay * MS_IN_DAY)).format('YYYY-MM-DD');
        } else if (dob && (dob.dd !== '0' || dob.mm !== '0' || dob.yyyy != '0')) {
            const dobDate = moment(`${dob.yyyy}-${dob.mm}-${dob.dd}`, 'YYYY-MM-DD');
            if (
                !dobDate.isValid() ||
                dobDate.isAfter(new Date()) ||
                dob.yyyy === '0' ||
                !dob.dd ||
                !dob.mm ||
                !dob.yyyy
            ) {
                // moment js consider 0 as 2000
                setIsDobError(true);
                setIsAgeDOBError(false);
                return {
                    success: false,
                    data: { isAgeDOBAbsent, isDobError, name, phoneNumber, gender },
                };
            } else {
                dobStr = dobDate.format('YYYY-MM-DD');
                setIsDobError(false);
                setIsAgeDOBError(false);
            }
        }

        return { success: true, dobStr };
    };

    const onAdd = (): void => {
        if (isAbhaOnboarded && !showAbhaCard && formState === 'add-pt') {
            ekaEventDispath({ type: PATIENT_ABHA_CREATE });
        }

        const result = errorValidation();

        if (result.success && name) {
            const newPatient: AddPatientNewPatient = {
                phCode,
                name,
                phoneNumber,
                age: result.dobStr ? { dob: result.dobStr } : { value: age, month: ageMonth },
                gender: gender?.toString() || '',
                formData: dForm?.map((df) => ({
                    ...df,
                    value: dfValues[df.key],
                })),
                refer_doc_id: referDocId,
            };

            onSave(newPatient);
            track('ADD_PATIENT_QUEUE_SAVE');
        } else {
            notification.error({
                message: 'Please fill all the required fields',
                duration: 5,
            });

            if (showAbhaCard) {
                const error = `Please fill all the required fields: 
                    name: ${result.data?.name}, 
                    phoneNumber: ${result.data?.phoneNumber}, 
                    gender: ${result.data?.gender}, 
                    isAgeDOBAbsent: ${result.data?.isAgeDOBAbsent}, 
                    isDobError: ${result.data?.isDobError}`;

                // captureError(new Error(`ABHA: ${error}`));

                track('ADD_PATIENT_VALIDATION_FAILED', {
                    isNewAbhaFlow: String(showAbhaCard),
                    name: result.data?.name,
                    phoneNumber: result.data?.phoneNumber,
                    gender: result.data?.gender,
                    isAgeDOBAbsent: String(result.data?.isAgeDOBAbsent),
                    isDobError: String(result.data?.isDobError),
                });
            }
        }
    };

    const onDobChange = (dateValue: moment.Moment | null) => {
        if (dateValue) {
            setCurrentMomentDate(dateValue);
            const momentDate = dateValue;
            const date = momentDate.date().toString();
            const month = (momentDate.month() + 1).toString();
            const year = momentDate.year().toString();

            onDDDobChange(date);
            onMMDobChange(month);
            onYYYYDobChange(year);
        }
    };

    const onSave = async (newP: AddPatientNewPatient): Promise<void> => {
        const newPatient = {
            ...newP,
            // localId: this.props.location?.state?.oid || undefined,
            localId: abhaPtOid,
            // oid: this.props.location?.state?.oid || undefined,
            oid: abhaPtOid,
        };
        setIsAddingPatient(true);
        const onSuccess = (patient: Patient & { apiFailure: boolean; error?: Error }) => {
            if (patient.apiFailure === true) {
                ekaEventDispath({
                    type: ADD_NEW_PT_APPT,
                    data: undefined,
                });

                notification.error({
                    message: 'Failed to add patient. Please try again',
                    duration: 5,
                });

                track('ERROR', {
                    on: 'onSave',
                    error: (patient.error as Error)?.message,
                });
            } else {
                ekaEventDispath({
                    type: ADD_NEW_PT_APPT,
                    data: patient,
                });
                callback && callback(patient);
                track('ADD_PT_NEW_VIEW_SUCCESS');

                close();
            }
            setIsAddingPatient(false);
        };

        const settings = await getItemFromMisc<GenieSettings>(
            getMyDbId() || '',
            MISC_KEYS.settings,
        );

        const myDoc = getDoctorSelectorList().find((doc) => doc.id === docid);
        // if (!myDoc) {
        //     alert("Doctor's data not found" + docid);
        //     captureError(new Error("Doctor's data not found: docid: " + docid));
        //     return;
        // }
        //dispatching for the case of !myDoc as well for business level patients
        dispatch(
            addPatient({
                newPatient,
                sendWelcome: settings.sendWelcome,
                onSuccess,
                visitid: undefined,
                doc: myDoc,
                onError: (error: string) => {
                    notification.error({
                        message: 'Failed to add patient',
                        description: error,
                    });
                    setIsAddingPatient(false);
                },
            }),
        );

        return;
    };

    const resetError = () => {
        setIsNameError(false);
        setIsAgeDOBError(false);
        setIsDobError(false);
        setIsGenderError(false);
        setIsPhoneNumberError(false);
        setIsReferralPhoneNumberError(false);
    };

    const salutationChangeHandler = (e?: React.ChangeEvent<HTMLSelectElement>): void => {
        salutation && onDFChange(salutation)(e?.target.value ?? '');

        if (e?.target.value) {
            MALE_SALUTATION.has(e.target.value ?? '')
                ? onGenderChange('Male')
                : e.target.value === ''
                ? onGenderChange('Other')
                : onGenderChange('Female');
        }
    };

    const onAutoComplete = (patient?: Patient): void => {
        if (!isSendAbhaOtp && isAbhaOnboarded && !showAbhaCard && formState === 'add-pt') {
            ekaEventDispath({
                type: NEW_PT_FORM_DATA_AS_SELECTED,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data: { ...patient, localId: undefined },
            });
        }

        if (!patient) {
            if (fromNdhmDiscovery) {
                setFromNdhmDiscovery(false);
                setAuthHealthId(undefined);
                setName(undefined);
                setGender(undefined);
            }
            return;
        }

        if (patient.id && formState === 'add-pt') {
            ekaEventDispath({
                type: ADD_NEW_PT_APPT,
                data: patient,
            });
            callback && callback(patient);
            track('ADD_PT_NEW_VIEW_SUCCESS');

            close();

            return;
        }

        const { personal } = patient;
        const { name, phone, age, gender } = personal;
        const referredByNumber = patient?.formData?.find((form) => form.key === 'referredbynumber');

        setAbhaId(patient.abha?.id);
        setAutoSelectPt(patient);
        setLocalId(patient.localId);
        setPhCode(phone?.c || phCode);
        setPtId(patient.id);
        setName(name.f + (name.l ? name.l : ''));
        setPhoneNumber(phone?.n);
        setIsPhoneNumberError(
            phone?.n ? !checkIfValidPhoneNumber(phone?.c || '', phone?.n) : false,
        );
        setGender(capitalizeString(gender) as Gender);
        setIsNameError(false);
        setIsGenderError(false);
        setIsAgeDOBError(false);
        setDfValues(
            patient.formData?.reduce((agg, df) => ({ ...agg, [df.key]: df.value }), {}) || {},
        );
        setAuthHealthId(
            patient.personal['health-ids'] ? patient.personal['health-ids'][0] : undefined,
        );
        setIsReferralPhoneNumberError(
            referredByNumber
                ? !checkIfValidPhoneNumber('+91', `${referredByNumber?.value}`, 'IN')
                : false,
        );

        const ageValue = decodeAge(age);
        setDob(ageValue.dob);
        setAge(ageValue.age);
        setAgeMonth(ageValue.ageMonth);
        setCurrentMomentDate(
            ageValue.dob?.dd && ageValue.dob?.mm && ageValue.dob?.yyyy
                ? moment({
                      month: parseInt(ageValue.dob?.mm) - 1,
                      date: parseInt(ageValue.dob?.dd),
                      year: parseInt(ageValue.dob?.yyyy),
                  })
                : null,
        );
        setFromNdhmDiscovery(patient?.personal?.fromNdhmDiscovery);

        if (formState === 'abha') {
            if (patient.abha?.id) {
                setAbhaFields({ skipState: 'abha_end', abhaId: patient.abha.id });
                setAddPtFormStateWithTracking('add-pt');
                return;
            }
        }

        return;
    };

    const openConfigure = () => {
        setConfigureDialogVisible(true);
    };

    const disabledDate: RangePickerProps['disabledDate'] = (current) => {
        // Can not select days after today and today
        return current && current > moment().endOf('day');
    };

    const closeConfigureDialog = () => {
        setConfigureDialogVisible(false);
    };

    const setAbhaFields = (opt: { skipState: string; abhaId: string | undefined }) => {
        setShowOtherFields(true);
        setShowAbhaCard(true);
        setAbhaId(opt.abhaId);
        setCreateSkipState(opt.skipState);
    };

    const onAddEkaRefer = (referDocId?: string, name?: string, number?: string) => {
        setReferDocId(referDocId);
        setDfValues({
            ...dfValues,
            referredby: name || '',
            referredbynumber: number || '',
        });
        setIsReferralPhoneNumberError(
            number ? !checkIfValidPhoneNumber('+91', `${number}`, 'IN') : false,
        );
    };
    const setShowSendOtpScreenHandler = (val: boolean) => setShowSendOtpScreen(val);

    const validatePhoneNumber = (input: string, countryCodeEnum: CountryCode) => {
        if (!input) setIsPhoneNumberError(false);
        if (phCode && input && countryCodeEnum) {
            setIsPhoneNumberError &&
                setIsPhoneNumberError(!checkIfValidPhoneNumber(phCode, input, countryCodeEnum));
        }
    };

    return formState === 'abha' ? (
        <CreateAbhaForm
            phCode={phCode}
            currMomentDate={currMomentDate}
            currMonthLoss={currMonthLoss}
            dfValues={dfValues}
            disabledDate={disabledDate}
            isAgeDOBError={isAgeDOBError}
            isDobError={isDobError}
            isNameError={isNameError}
            isPhoneNumberError={isPhoneNumberError}
            name={name}
            onAgeSelect={onAgeSelect}
            onAutoComplete={onAutoComplete}
            onDobChange={onDobChange}
            onNameChange={onNameChange}
            onPhoneNumberChange={onPhoneNumberChange}
            phoneNumber={phoneNumber}
            salutation={salutation}
            salutationChangeHandler={salutationChangeHandler}
            value={value}
            setAddPtFormState={setAddPtFormStateWithTracking}
            isGenderInputDisabled={isGenderInputDisabled}
            isGenderError={isGenderError}
            onGenderChange={onGenderChange}
            gender={gender}
            setAbhaFields={setAbhaFields}
            ageDays={ageDays}
            ageMonth={ageMonth}
            dob={dob}
            isModal={true}
            patientId={ptId}
            authHealthId={authHealthId}
            setAuthHealthId={(val: string | undefined) => setAuthHealthId(val)}
            showSendOtpScreen={showSendOtpScreen}
            setShowSendOtpScreen={setShowSendOtpScreenHandler}
            abhaId={abhaId}
            setIsPhoneNumberError={(val: boolean) => setIsPhoneNumberError(val)}
            errorValidation={errorValidation}
            resetError={resetError}
            abhaLinkPatient={abhaLinkPatient}
            closeModal={close}
            onAbhaLink={onAbhaLink}
            setShowAbhaCard={(val: boolean) => setShowAbhaCard(val)}
            fromNdhmDiscovery={fromNdhmDiscovery}
            defaultAbhaId={defaultAbhaId}
            cId={cId}
            setAbhaPtOid={setAbhaPtOid}
        />
    ) : (
        <Fragment>
            {/* {!hideABHAFlow && isAbdmEnabled && isAbhaOnboarded && !showAbhaCard && (
                <>
                    {isSendAbhaOtp && showSendOtp && (
                        <div className="p-16 absolute -right-192 top-44 bg-white rounded-8">
                            <button
                                className={`cursor-pointer flex py-8 px-16 gap-4 items-center justify-center rounded-4 bg-darwin-accent-bright-blue-800 ${
                                    checkIfValidPhoneNumber(phCode, phoneNumber, 'IN')
                                        ? ''
                                        : 'opacity-50'
                                }`}
                                style={{ width: 'fit-content', height: 'fit-content' }}
                                onClick={() => {
                                    if (checkIfValidPhoneNumber(phCode, phoneNumber, 'IN')) {
                                        setShowSendOtp(false);
                                        onSendOtp && onSendOtp();
                                    }
                                }}
                                disabled={
                                    checkIfValidPhoneNumber(phCode, phoneNumber, 'IN')
                                        ? false
                                        : true
                                }
                            >
                                <p className="text-white text-14 font-700">Send ABHA OTP</p>
                                <svg
                                    className="fill-white font-700"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    width={12}
                                    height={12}
                                >
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                                </svg>
                            </button>
                        </div>
                    )}
                    <div
                        className={`absolute -right-386 w-384 bg-white rounded-10  ${
                            isSendAbhaOtp && showSendOtp ? 'hidden' : ''
                        }`}
                    >
                        <div className="w-full border-b border-darwin-neutral_new-200">
                            <div className="mx-12 mt-10 mb-0 flex items-center gap-8 mb-8">
                                <span>{AbhaIconNotLinked}</span>
                                <p className="text-20 font-400">Patient ABHA</p>
                            </div>
                        </div>
                        <div className="max-w-400 overflow-scroll hide-scrollbar">
                            <div className="p-12 pb-0" id={ABHA_IN_DOCTOOL_CONTAINER}></div>
                        </div>
                        <CurrMonthLossStrip currMonthLoss={currMonthLoss} className="mt-4 gap-8" />
                    </div>
                </>
            )} */}
            {/* {!hideABHAFlow && !isAbhaOnboarded && getMe()?.user['is-d'] && (
                <div className={`absolute -right-386 w-384 bg-white rounded-10`}>
                    <NoABDMPopver
                        subTitle={
                            <p className="text-12 font-400">
                                Enroll into DHIS and start earning now.
                            </p>
                        }
                    />
                </div>
            )} */}
            {configureDialogVisible ? (
                <ConfigureDyFormsDialog
                    closeMe={closeConfigureDialog}
                    onDyFormUpdate={updateDform}
                />
            ) : (
                <Fragment>
                    <div className="flex items-center justify-between p-16 rounded-t-4">
                        {!abhaLinkPatient ? (
                            <p className="text-14 font-700 leading-5 bold text-neutral-1">
                                Patient ABHA
                            </p>
                        ) : (
                            <p className="text-14 font-700 leading-5 bold text-neutral-1">
                                Add New Patient
                            </p>
                        )}

                        {!abhaLinkPatient && (
                            <div className="flex space-x-4 items-center">
                                {/* <ToggleAbhaFlowVersion iconHeight="14px" /> */}
                                <div
                                    onClick={openConfigure}
                                    className="flex items-center justify-center w-16 h-16 cursor-pointer"
                                >
                                    <svg
                                        width="14"
                                        height="15"
                                        viewBox="0 0 14 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13.7812 9.39062C13.7812 10.1289 12.3594 12.918 11.4297 12.918C11.3203 12.918 11.2109 12.8906 11.1016 12.8086L10.1992 12.2891C9.89844 12.5078 9.59766 12.6992 9.26953 12.8359V13.875C9.26953 14.1758 9.07812 14.4492 8.77734 14.5312C8.17578 14.6953 7.57422 14.75 6.97266 14.75C6.37109 14.75 5.76953 14.6953 5.16797 14.5039C4.89453 14.4219 4.67578 14.1484 4.67578 13.8477V12.8086C4.34766 12.6719 4.04688 12.4805 3.74609 12.2617L2.84375 12.7812C2.73438 12.8633 2.625 12.8906 2.51562 12.8906C1.55859 12.8906 0.191406 9.96484 0.191406 9.39062C0.191406 9.17188 0.328125 8.95312 0.546875 8.81641L1.44922 8.29688C1.42188 8.13281 1.42188 7.94141 1.42188 7.75C1.42188 7.58594 1.42188 7.39453 1.44922 7.23047L0.546875 6.71094C0.328125 6.57422 0.191406 6.35547 0.191406 6.13672C0.191406 5.39844 1.61328 2.60938 2.51562 2.60938C2.625 2.60938 2.73438 2.63672 2.84375 2.71875L3.74609 3.23828C4.04688 3.01953 4.34766 2.82812 4.67578 2.69141V1.65234C4.67578 1.35156 4.89453 1.07812 5.16797 0.996094C5.76953 0.832031 6.37109 0.75 7 0.75C7.60156 0.75 8.20312 0.832031 8.80469 0.996094C9.07812 1.07812 9.29688 1.35156 9.29688 1.65234V2.69141C9.625 2.82812 9.92578 3.01953 10.2266 3.23828L11.1289 2.71875C11.2383 2.63672 11.3477 2.60938 11.457 2.60938C12.4141 2.60938 13.7812 5.53516 13.7812 6.13672C13.7812 6.35547 13.6445 6.57422 13.4258 6.71094L12.5234 7.23047C12.5508 7.39453 12.5508 7.58594 12.5508 7.75C12.5508 7.94141 12.5508 8.13281 12.5234 8.26953L13.4258 8.78906C13.6445 8.92578 13.7812 9.14453 13.7812 9.39062ZM11.3477 11.4141C11.7578 10.9219 12.1133 10.3203 12.332 9.69141L11.1562 9.00781C11.2109 8.32422 11.2383 8.02344 11.2383 7.75C11.2383 7.47656 11.2109 7.20312 11.1562 6.51953L12.332 5.83594C12.1133 5.20703 11.7578 4.60547 11.3477 4.11328L10.1445 4.79688C8.99609 3.94922 9.26953 4.11328 7.98438 3.53906V2.17188C7.73828 2.11719 7.41016 2.0625 7 2.0625C6.69922 2.0625 6.34375 2.08984 5.98828 2.17188V3.53906C4.70312 4.11328 4.97656 3.94922 3.82812 4.79688L2.625 4.08594C2.21484 4.60547 1.85938 5.20703 1.64062 5.83594L2.81641 6.51953C2.76172 7.20312 2.73438 7.47656 2.73438 7.75C2.73438 8.05078 2.76172 8.32422 2.81641 9.00781L1.64062 9.66406C1.85938 10.3203 2.21484 10.8945 2.625 11.4141L3.82812 10.7031C4.97656 11.5508 4.70312 11.3867 5.98828 11.9609V13.3281C6.20703 13.3828 6.5625 13.4375 6.97266 13.4375C7.27344 13.4375 7.62891 13.4102 7.98438 13.3281V11.9609C9.26953 11.3867 8.99609 11.5508 10.1445 10.7031L11.3477 11.4141ZM7 5.125C8.42188 5.125 9.625 6.30078 9.625 7.75C9.625 9.17188 8.42188 10.375 7 10.375C5.55078 10.375 4.375 9.17188 4.375 7.75C4.375 6.30078 5.55078 5.125 7 5.125ZM7 9.0625C7.71094 9.0625 8.3125 8.48828 8.3125 7.75C8.3125 7.03906 7.71094 6.4375 7 6.4375C6.26172 6.4375 5.6875 7.03906 5.6875 7.75C5.6875 8.48828 6.26172 9.0625 7 9.0625Z"
                                            fill="black"
                                        />
                                    </svg>
                                </div>
                            </div>
                        )}
                    </div>
                    <div
                        className="flex items-center h-full py-8 px-16 rounded-t-4 gap-24 overflow-auto hide-scrollbar"
                        style={{ flexDirection: 'column' }}
                    >
                        {showAbhaCard && (
                            <AbhaCard
                                abhaId={abhaId}
                                ageDays={ageDays}
                                ageMonth={ageMonth}
                                createSkipState={createSkipState}
                                dob={dob}
                                gender={gender}
                                name={name}
                                phoneNumber={phoneNumber}
                                className="w-full"
                            />
                        )}
                        {!abhaLinkPatient && (
                            <Fragment>
                                {!showAbhaCard && (
                                    <div className="w-full">
                                        <div className="w-full flex flex-col gap-16 justify-between items-center">
                                            <PatientPhoneAutoSuggestBlock
                                                phCode={phCode}
                                                onPhoneNumberChange={onPhoneNumberChange}
                                                onPhCodeChange={
                                                    isPhCode ? onPhCodeChange : undefined
                                                }
                                                onAutoComplete={onAutoComplete}
                                                suggestionsEnabled={false}
                                                disabled={isPhoneInputDisabled}
                                                phoneNumber={phoneNumber ?? ''}
                                                isPhoneNumberError={isPhoneNumberError}
                                                isModal={true}
                                                onBlur={validatePhoneNumber}
                                                phCodeEnum={phCodeEnum}
                                                cid={cId || params.cId || getSelectedClinicId()}
                                                isAbdmEnabled={isAbdmEnabled}
                                                fromNdhmDiscovery={fromNdhmDiscovery}
                                            />
                                            {fromNdhmDiscovery &&
                                            name &&
                                            phoneNumber?.length === 10 &&
                                            gender ? (
                                                <div className="rounded-8 w-full bg-darwin-neutral_new-50 px-10 py-8 gap-4 flex items-center">
                                                    <span className="self-start">
                                                        {AbhaIconNotLinked}
                                                    </span>
                                                    <div className="flex flex-col gap-4">
                                                        <p className="text-13 font-700">
                                                            {name} | {gender?.slice(0, 1)}
                                                        </p>
                                                        <p className="text-12 font-400">
                                                            {phoneNumber} | {authHealthId}
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                )}

                                {!showAbhaCard && (
                                    <PatientNameAutoSuggestBlock
                                        dfValues={dfValues}
                                        disabled={isNameInputDisabled}
                                        onAutoComplete={onAutoComplete}
                                        onNameChange={onNameChange}
                                        salutation={salutation}
                                        salutationChangeHandler={salutationChangeHandler}
                                        suggestionsEnabled={false}
                                        name={name}
                                        isNameError={isNameError}
                                        isNameInputDisabled={isNameInputDisabled}
                                        isModal={true}
                                        isPhCode={!!isPhCode}
                                    />
                                )}
                                {uhidDForm && (
                                    <div className="flex w-full justify-between">
                                        <PatientUhidAutoSuggest
                                            inputValue={uhid ?? ''}
                                            onInputChange={onUhidInputChange}
                                            onSelect={onAutoComplete}
                                            suggestionsEnabled={false}
                                            isModal={true}
                                            isPhCode={!!isPhCode}
                                        />
                                        <SuggestUHID
                                            setUHID={onDFChange(uhidDForm)}
                                            isAlreadyPresent={
                                                (dfValues[uhidDForm.key]?.toString() || '').length >
                                                0
                                            }
                                            isModal={true}
                                        />
                                    </div>
                                )}
                                {!showAbhaCard && (
                                    <AgeInputBlock
                                        disabledDate={disabledDate}
                                        isAgeInputDisabled={isAgeInputDisabled}
                                        isAgeDOBError={isAgeDOBError}
                                        isDobError={isDobError}
                                        momentDate={currMomentDate}
                                        onAgeSelect={onAgeSelect}
                                        onDobChange={onDobChange}
                                        value={value}
                                        isModal={true}
                                    />
                                )}

                                {!showAbhaCard && (
                                    <div className="space-y-4 w-full flex">
                                        <GenderBlock
                                            gender={gender}
                                            isGenderError={isGenderError}
                                            isGenderInputDisabled={isGenderInputDisabled}
                                            onGenderChange={onGenderChange}
                                            isModal={true}
                                        />
                                    </div>
                                )}
                                <div className="w-full bottom-8 relative">
                                    {dFormWithoutUHID && dFormWithoutUHID.length > 0 ? (
                                        showOtherFields ? (
                                            <Row gutter={[16, 16]}>
                                                {dFormWithoutUHID
                                                    .filter((t) => t.key !== 'salutation')
                                                    .map((df) => {
                                                        if (df.key === 'referredbynumber') {
                                                            return null;
                                                        }

                                                        if (df.key === 'referredby') {
                                                            const referredByNumber = DYNAMIC_FORMS.find(
                                                                (form) =>
                                                                    form.key === 'referredbynumber',
                                                            );
                                                            return (
                                                                <Col span={24}>
                                                                    <div
                                                                        className="flex items-start w-full space-x-16 mh_component_add_pt"
                                                                        style={{
                                                                            paddingLeft: '8px',
                                                                        }}
                                                                    >
                                                                        <div className="w-full">
                                                                            <PatientReferralAutoSuggest
                                                                                onSelect={(
                                                                                    data,
                                                                                ) => {
                                                                                    onAddEkaRefer(
                                                                                        data?.id,
                                                                                        data?.name,
                                                                                        data?.number ||
                                                                                            (dfValues?.referredbynumber as string) ||
                                                                                            '',
                                                                                    );
                                                                                }}
                                                                                onInputChange={(
                                                                                    text,
                                                                                ) => {
                                                                                    onDFChange(df)(
                                                                                        text,
                                                                                    );
                                                                                }}
                                                                                inputValue={
                                                                                    (dfValues[
                                                                                        'referredby'
                                                                                    ] ||
                                                                                        '') as string
                                                                                }
                                                                                disabled={
                                                                                    isPhoneInputDisabled
                                                                                }
                                                                                suggestionsEnabled={
                                                                                    !name && !uhid
                                                                                }
                                                                                className="w-full"
                                                                                menuPlacement="top"
                                                                            />
                                                                        </div>
                                                                        {referredByNumber && (
                                                                            <div
                                                                                key={
                                                                                    referredByNumber.key
                                                                                }
                                                                                className="w-full"
                                                                            >
                                                                                <PatientPhoneNumber
                                                                                    onSelect={(
                                                                                        suggestion,
                                                                                    ) => {
                                                                                        onDFChange(
                                                                                            referredByNumber,
                                                                                        )(
                                                                                            suggestion?.value ||
                                                                                                '',
                                                                                        );
                                                                                    }}
                                                                                    onInputChange={(
                                                                                        text,
                                                                                    ) => {
                                                                                        onDFChange(
                                                                                            referredByNumber,
                                                                                        )(text);
                                                                                    }}
                                                                                    inputValue={
                                                                                        dfValues[
                                                                                            referredByNumber
                                                                                                .key
                                                                                        ]?.toString() ||
                                                                                        ''
                                                                                    }
                                                                                    phoneNumbers={
                                                                                        dyFormSuggestions[
                                                                                            referredByNumber.key.toLowerCase()
                                                                                        ] as number[]
                                                                                    }
                                                                                    isPhoneNumberError={
                                                                                        isReferralPhoneNumberError
                                                                                    }
                                                                                    className="w-full"
                                                                                    menuPlacement="top"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            );
                                                        }

                                                        return (
                                                            <Col span={12}>
                                                                <div
                                                                    className="relative flex items-center justify-between w-full bg-darwin-neutral-50"
                                                                    style={{
                                                                        padding: `0.625rem ${
                                                                            df.key ===
                                                                            'maritalstatus'
                                                                                ? '0.5rem'
                                                                                : '0.75rem'
                                                                        }`,
                                                                    }}
                                                                >
                                                                    {df.key === 'maritalstatus' ? (
                                                                        <Fragment>
                                                                            <select
                                                                                required
                                                                                value={
                                                                                    dfValues[
                                                                                        'maritalstatus'
                                                                                    ] || ''
                                                                                }
                                                                                onChange={(e) =>
                                                                                    onDFChange(df)(
                                                                                        e.target
                                                                                            .value,
                                                                                    )
                                                                                }
                                                                                className="w-full text-14 text-neutral-5 focus:outline-none bg-darwin-neutral-50"
                                                                                // placeholder="Marital Status"
                                                                            >
                                                                                <option value="">
                                                                                    Marital Status
                                                                                </option>
                                                                                {MARITAL_STATUS.map(
                                                                                    (v, i) => (
                                                                                        <option
                                                                                            key={
                                                                                                v +
                                                                                                i +
                                                                                                1
                                                                                            }
                                                                                            value={
                                                                                                v
                                                                                            }
                                                                                        >
                                                                                            {v}
                                                                                        </option>
                                                                                    ),
                                                                                )}
                                                                            </select>
                                                                            <div className="mimic-box"></div>
                                                                        </Fragment>
                                                                    ) : df.key === 'rpp' ? (
                                                                        <Fragment>
                                                                            <select
                                                                                required
                                                                                value={
                                                                                    dfValues[
                                                                                        'rpp'
                                                                                    ] || ''
                                                                                }
                                                                                onChange={(e) =>
                                                                                    onDFChange(df)(
                                                                                        e.target
                                                                                            .value,
                                                                                    )
                                                                                }
                                                                                className="w-full text-14 text-neutral-5 focus:outline-none bg-darwin-neutral-50"
                                                                                // placeholder="Marital Status"
                                                                            >
                                                                                <option
                                                                                    disabled
                                                                                    value=""
                                                                                >
                                                                                    Relationship
                                                                                    with patient
                                                                                </option>
                                                                                {FAMILY_MEMBERS_NAME.map(
                                                                                    (v) => (
                                                                                        <option
                                                                                            key={
                                                                                                v.id
                                                                                            }
                                                                                            value={
                                                                                                v.value
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                v.value
                                                                                            }
                                                                                        </option>
                                                                                    ),
                                                                                )}
                                                                            </select>
                                                                            <div className="mimic-box"></div>
                                                                        </Fragment>
                                                                    ) : df.key === 'lang' ? (
                                                                        <Fragment>
                                                                            <select
                                                                                value={
                                                                                    dfValues[
                                                                                        df.key
                                                                                    ] || ''
                                                                                }
                                                                                onChange={(e) =>
                                                                                    onDFChange(df)(
                                                                                        e.target
                                                                                            .value,
                                                                                    )
                                                                                }
                                                                                className="w-full text-14 text-neutral-5 focus:outline-none bg-darwin-neutral-50"
                                                                                // placeholder="Marital Status"
                                                                            >
                                                                                <option
                                                                                    disabled
                                                                                    value=""
                                                                                >
                                                                                    {df.label}
                                                                                </option>
                                                                                {LANGS.map((v) => (
                                                                                    <option
                                                                                        key={v.code}
                                                                                        value={
                                                                                            v.code
                                                                                        }
                                                                                    >
                                                                                        {v.label}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                            <div className="mimic-box"></div>
                                                                        </Fragment>
                                                                    ) : (
                                                                        <Fragment>
                                                                            <input
                                                                                placeholder={
                                                                                    df.label
                                                                                }
                                                                                value={
                                                                                    dfValues[
                                                                                        df.key
                                                                                    ]?.toString() ||
                                                                                    ''
                                                                                }
                                                                                onChange={(e) =>
                                                                                    onDFChange(df)(
                                                                                        e.target
                                                                                            .value,
                                                                                    )
                                                                                }
                                                                                className="focus:outline-none text-14 w-full bg-darwin-neutral-50"
                                                                                list={`new-pt-f-${df.key}`}
                                                                                autoComplete="nope"
                                                                            ></input>
                                                                            <datalist
                                                                                id={`new-pt-f-${df.key}`}
                                                                            >
                                                                                {dyFormSuggestions[
                                                                                    df.key.toLowerCase()
                                                                                ]?.map((t) => (
                                                                                    <option
                                                                                        value={t}
                                                                                    ></option>
                                                                                ))}
                                                                            </datalist>
                                                                            <div className="mimic-box"></div>
                                                                        </Fragment>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                            </Row>
                                        ) : (
                                            <p
                                                className="text-darwin-accent-bright-blue-800 cursor-pointer font-700 text-14 inline-block"
                                                onClick={() => setShowOtherFields(true)}
                                            >
                                                Show Other Fields
                                            </p>
                                        )
                                    ) : (
                                        <p
                                            className="text-darwin-accent-bright-blue-800 cursor-pointer font-700 text-14 inline-block"
                                            onClick={openConfigure}
                                        >
                                            + Add Fields
                                        </p>
                                    )}
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className="mt-auto flex items-center justify-between p-16">
                        {abhaLinkPatient ? (
                            <button
                                className={`border font-700 bg-darwin-accent-bright-blue-800 text-white justify-center p-8 w-full`}
                                onClick={() => {
                                    close();
                                    onAbhaLink && onAbhaLink(abhaLinkPatient);
                                }}
                                style={{
                                    borderRadius: '0.5rem',
                                }}
                            >
                                Done
                            </button>
                        ) : (
                            <Fragment>
                                {!hideABHAFlow && isAbdmEnabled && !showAbhaCard && isAbhaNewFlow && (
                                    <button
                                        className="border font-700 border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 justify-center p-8"
                                        onClick={() => {
                                            track('UNDO_SKIP_ABHA');
                                            setShowAbhaCard(true);
                                            setAddPtFormState && setAddPtFormState('abha');
                                        }}
                                        style={{
                                            borderRadius: '0.5rem',
                                        }}
                                    >
                                        Create ABHA
                                    </button>
                                )}
                                <button
                                    className={`flex items-center space-x-8 border font-700 bg-darwin-accent-bright-blue-800 text-white justify-center p-8 ${
                                        (showAbhaCard ||
                                            !isAbdmEnabled ||
                                            hideABHAFlow ||
                                            !isAbhaNewFlow) &&
                                        'w-full'
                                    } disabled:opacity-70 disabled:cursor-not-allowed`}
                                    onClick={onAdd}
                                    style={{
                                        borderRadius: '0.5rem',
                                    }}
                                    disabled={isAddingPatient}
                                >
                                    <p>Add Patient</p>
                                    {isAddingPatient && (
                                        <p>
                                            <svg
                                                className="w-16 h-16 fill-white animate-spin"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                            >
                                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                            </svg>
                                        </p>
                                    )}
                                </button>
                            </Fragment>
                        )}
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

type T = GeniePadElementsSettingItem & DFormEntity;

const ConfigureDyFormsDialog: React.FC<{
    closeMe: () => void;
    onDyFormUpdate: () => void;
}> = ({ closeMe, onDyFormUpdate }) => {
    const [dyFormsConfig, setDyFormsConfig] = useState<T[]>([] as T[]);

    const dispatch = useDispatch();

    useEffect(() => {
        getAddPDForms()
            .then((res) => {
                const resSet = new Set(res.map((r) => r.key));
                const mergedConfig = [...res, ...DYNAMIC_FORMS].filter(
                    (c, index, arr) =>
                        index === arr.findIndex((curr) => curr.key === c.key) && c.key !== 'uhid',
                );
                setDyFormsConfig(
                    mergedConfig
                        .map((i) => {
                            if (i.key === 'referredby') {
                                const data = DYNAMIC_FORMS.find((dyform) => dyform.key === i.key);
                                return {
                                    id: i.key,
                                    name: data?.label || '',
                                    isShown: resSet.has(i.key),
                                    ...i,
                                };
                            }
                            return {
                                id: i.key,
                                name: i.label,
                                isShown: resSet.has(i.key),
                                ...i,
                            };
                        })
                        ?.filter((config) => config?.id !== 'referredbynumber'),
                );
            })
            .catch(console.error);
    }, []);

    const onSave = async (items: T[]): Promise<void> => {
        dispatch(
            updateAddPtDyForm(
                items
                    .filter((d) => d.isShown)
                    .map((d) => ({
                        label: d.label,
                        type: d.type,
                        key: d.id,
                    })),
            ),
        );
        closeMe();
        onDyFormUpdate();
    };

    return (
        <CongigureElemtsTableDialog
            title="Configure Add Patient"
            configTableTitle={'Order of fields in “Add patient”'}
            closeMe={closeMe}
            onUpdate={onSave}
            config={dyFormsConfig}
        />
    );
};

export const AddPtModal: React.FC<
    Props & { style?: React.CSSProperties; topContent?: React.ReactNode }
> = ({
    cId,
    close,
    callback,
    hideABHAFlow,
    defaultFormState,
    isAbhaNewFlow,
    abhaLinkPatient,
    onAbhaLink,
    docid,
    style,
    topContent,
    defaultAbhaId,
    initialState,
    defaultShowAbhaCard,
    defaultAbhaPtOid,
}) => {
    const [formState, setFormState] = useState<IFormState>(defaultFormState ?? 'add-pt');
    const isSendAbhaOtp = useSelector(
        (state: GlobalStateV1) => getGenieSetting(state, 'isSendAbhaOtp') as boolean,
    );

    const setAddPtFormState = (formstate: IFormState | undefined) => {
        setFormState(formstate ?? defaultFormState ?? 'add-pt');
    };

    return (
        <NewPatientModalWrapper
            className="modal-content w-33p h-3/4 flex flex-col hide-scrollbar rounded-16"
            callback={callback}
            close={close}
            style={style}
        >
            {topContent}
            <NewPatientModal
                cId={cId}
                callback={callback}
                close={close}
                hideABHAFlow={hideABHAFlow}
                formState={formState}
                setAddPtFormState={setAddPtFormState}
                isAbhaNewFlow={isAbhaNewFlow}
                abhaLinkPatient={abhaLinkPatient}
                onAbhaLink={onAbhaLink}
                isSendAbhaOtp={isSendAbhaOtp}
                docid={docid}
                defaultAbhaId={defaultAbhaId}
                initialState={initialState}
                defaultShowAbhaCard={defaultShowAbhaCard}
                defaultAbhaPtOid={defaultAbhaPtOid}
            />
        </NewPatientModalWrapper>
    );
};

export default NewPatientModal;
